/** 布局尺寸单一事实来源（Drawer / Modal 档位） */
export const layoutTokens = {
  drawer: {
    sm: 480,
    md: 720,
    lg: 960,
    /** 运单详情等宽侧滑：约整页 3/4 */
    xl: '75vw',
  },
  modal: {
    sm: 480,
    md: 560,
    lg: 720,
    xl: 960,
  },
} as const;

export type DrawerSize = keyof typeof layoutTokens.drawer;
export type ModalSize = keyof typeof layoutTokens.modal;
